import React from "react";
import { Phone, Mail, MapPin } from "lucide-react";

export const Contact = () => (
  <div className="max-w-4xl mx-auto px-4 py-12">
    <h1 className="text-3xl md:text-4xl font-black text-slate-900">Contact Us</h1>
    <p className="text-slate-600 mt-2">We're here to help you with your medical supply needs.</p>

    <div className="mt-8 grid md:grid-cols-3 gap-6">
      {[
        { icon: Phone, title: "Phone", value: "1 (888) 286-9244", sub: "Mon–Fri 9a–6p EST" },
        { icon: Mail, title: "Email", value: "support@izzimedicalsupplies.com", sub: "Response within 24 hours" },
        { icon: MapPin, title: "Address", value: "1871 Woodslee Dr", sub: "Troy, MI 48083" },
      ].map(({ icon: Icon, title, value, sub }) => (
        <div key={title} className="bg-white border border-slate-200 rounded-lg p-6">
          <div className="w-10 h-10 rounded-md bg-[#0b3d75]/10 text-[#0b3d75] flex items-center justify-center">
            <Icon className="w-5 h-5" />
          </div>
          <div className="mt-3 font-bold text-slate-900">{title}</div>
          <div className="font-semibold text-[#0b3d75]">{value}</div>
          <div className="text-xs text-slate-500 mt-1">{sub}</div>
        </div>
      ))}
    </div>
  </div>
);

export const StaticPage = ({ title, children }) => (
  <div className="max-w-3xl mx-auto px-4 py-12">
    <h1 className="text-3xl md:text-4xl font-black text-slate-900">{title}</h1>
    <div className="mt-6 prose text-slate-700 space-y-4 leading-relaxed">
      {children}
    </div>
  </div>
);

export const Shipping = () => (
  <StaticPage title="Shipping Information">
    <p>We ship all orders from our Troy, Michigan warehouse and partner distribution centers. Most in-stock items ship within 1 business day.</p>
    <ul className="list-disc pl-5 space-y-2">
      <li><b>Free Standard Shipping</b> on orders over $75.</li>
      <li>Standard Shipping (2–5 business days): $9.95 flat rate for orders under $75.</li>
      <li>Expedited and next-day options are available at checkout.</li>
      <li>We ship to all 50 U.S. states.</li>
    </ul>
  </StaticPage>
);

export const Returns = () => (
  <StaticPage title="Returns Policy">
    <p>Your satisfaction is our priority. Most unopened items can be returned within 30 days of delivery for a full refund of the item price.</p>
    <ul className="list-disc pl-5 space-y-2">
      <li>Items must be unopened, unused, and in original packaging.</li>
      <li>Hygienic items (catheters, ostomy supplies, incontinence products) cannot be returned once opened.</li>
      <li>Contact us for a Return Authorization number before shipping items back.</li>
    </ul>
  </StaticPage>
);

export const Privacy = () => (
  <StaticPage title="Privacy Policy">
    <p>Izzi Medical Supplies respects your privacy. We collect only the information necessary to process your order and provide customer support.</p>
    <p>We never sell your personal information. Payment information is processed securely through Square and never stored on our servers.</p>
  </StaticPage>
);

export const Terms = () => (
  <StaticPage title="Terms of Service">
    <p>By using izzimedicalsupplies.com, you agree to the following terms.</p>
    <p>All product information is provided for informational purposes and is not a substitute for professional medical advice. Consult your healthcare provider before use.</p>
  </StaticPage>
);
